import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeFormatter',
  standalone: false
})
export class TimeFormatterPipe implements PipeTransform {
  public transform(input: number | undefined): string {
    if (!input) {
      return '00:00:00';
    }
    const hours = input / (60 * 60);
    const absoluteHours = Math.floor(hours);
    const h =
      absoluteHours > 9 ? absoluteHours : '0' + absoluteHours.toString();

    // Get remainder from hours and convert to minutes
    const minutes = (hours - absoluteHours) * 60;
    const absoluteMinutes = Math.floor(minutes);
    const m =
      absoluteMinutes > 9 ? absoluteMinutes : '0' + absoluteMinutes.toString();

    // Get remainder from minutes and convert to seconds
    const seconds = (minutes - absoluteMinutes) * 60;
    const absoluteSeconds = Math.floor(seconds);
    const s =
      absoluteSeconds > 9 ? absoluteSeconds : '0' + absoluteSeconds.toString();

    return h.toString() + ':' + m.toString() + ':' + s.toString();
  }
}
